<div class="modal fade" id="kt_modal_transmission_add_edit" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-650px">
    <div class="modal-content">
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary">
        <h2 class="fw-bold m-0">{{ isEditMode ? 'Update Transmission' : 'Add Transmission' }}</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <form [formGroup]="transmissionForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="modal-body p-5">
          <div class="row">
            <!-- Transmission Name -->
            <div class="col-md-12 mb-5">
              <label class="form-label required">Name</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="name"
                placeholder="Enter transmission name"
                [class.is-invalid]="name?.invalid && name?.touched"
              />
              <div *ngIf="name?.invalid && name?.touched" class="invalid-feedback">
                <div *ngIf="name?.errors?.['required']">Transmission name is required</div>
                <div *ngIf="name?.errors?.['minlength']">Transmission name must be at least 2 characters</div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-light me-3"
            data-bs-dismiss="modal"
            [disabled]="isLoading">
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="isLoading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
            {{ isEditMode ? 'Update' : 'Add' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
